import { render, staticRenderFns } from "./DashboardV2.vue?vue&type=template&id=7ccf8fe6&scoped=true"
import script from "./DashboardV2.vue?vue&type=script&lang=js"
export * from "./DashboardV2.vue?vue&type=script&lang=js"
import style0 from "./DashboardV2.vue?vue&type=style&index=0&id=7ccf8fe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccf8fe6",
  null
  
)

export default component.exports